// Chakra imports
import {
  Box,
  Button,
  Flex,
  SimpleGrid,
  Stack,
  Tab,
  TabList,
  TabPanel,
  TabPanels,
  Tabs,
  Text,
  useColorModeValue,
  useToast
} from '@chakra-ui/react';
import { useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
// Custom components
import Card from '../../../../components/card/Card';
import InputField from '../../../../components/fields/InputField';
import { addManager } from '../hooks';
import { LoadingSpinner } from "../../../../constants/helper";

export default function NewManager() {
  const textColor = useColorModeValue('secondaryGray.900', 'white');
  const [activeBullets, setActiveBullets] = useState({
    user: true,
    address: false,
  });

  const [loading, setLoading] = useState(false);
  const toast = useToast();
  const navigate = useNavigate(); // Initialize the navigate function

  const [values, setValues] = useState({
    firstName: "",
    lastName: "",
  });

  const handleChange = (e) => {
    setValues({ ...values, [e.target.name]: e.target.value });
  }

  const handleSubmit = async () => {
    setLoading(true);
    try {
      let res = await addManager(values);
      if (res.success) {
        toast({
          title: "Manager Info added successfully.",
          status: "success", // could be success, error, or info
          duration: 5000, // time in ms before the toast disappears
          isClosable: true, // allows user to manually close the toast
          position: "top-right",
        });
        navigate('/main/managers/managers-overview');
      }
      else {
        toast({
          title: "Error",
          description: `${res?.data}`,
          status: "error", // could be success, error, or info
          duration: 5000, // time in ms before the toast disappears
          isClosable: true, // allows user to manually close the toast
          position: "top-right",
        });
      }
    }
    catch (err) {
      toast({
        title: "Error",
        description: `${err}`,
        status: "error", // could be success, error, or info
        duration: 5000, // time in ms before the toast disappears
        isClosable: true, // allows user to manually close the toast
        position: "top-right",
      });
    }
    finally {
      setLoading(false);
    }
  }
  const userTab = useRef();
  const addressTab = useRef();

  return (
    <>
      {
        loading ? <LoadingSpinner />
          :
          <Flex
            direction="column"
            minH="100vh"
            align="center"
            pt={{ sm: '125px', lg: '75px' }}
            position="relative"
          >
            <Box
              h="45vh"
              bgGradient="linear(to-b, brand.400, brand.600)"
              position="absolute"
              w="100%"
              borderRadius="20px"
            />

            <Tabs
              variant="unstyled"
              zIndex="0"
              mt={{ base: '60px', md: '165px' }}
              display="flex"
              flexDirection="column"
            >
              <TabList
                display="flex"
                alignItems="center"
                alignSelf="center"
                justifySelf="center"
              >
                <Tab
                  _focus={{ border: '0px', boxShadow: 'unset' }}
                  ref={userTab}
                  w={{ sm: '120px', md: '250px', lg: '300px' }}
                  onClick={() =>
                    setActiveBullets({
                      user: true,
                      address: false,
                    })
                  }
                >
                  <Flex
                    direction="column"
                    justify="center"
                    align="center"
                    position="relative"
                    _before={{
                      content: "''",
                      width: { sm: '120px', md: '250px', lg: '308px' },
                      height: '3px',
                      bg: activeBullets.address ? 'white' : 'brand.400',
                      left: { sm: '12px', md: '45px' },
                      top: {
                        sm: activeBullets.user ? '6px' : '4px',
                        md: null,
                      },
                      position: 'absolute',
                      bottom: activeBullets.user ? '40px' : '38px',

                      transition: 'all .3s ease',
                    }}
                  >
                    <Box
                      zIndex="1"
                      border="2px solid"
                      borderColor={activeBullets.user ? 'white' : 'brand.400'}
                      bgGradient="linear(to-b, brand.400, brand.600)"
                      w="16px"
                      h="16px"
                      mb="8px"
                      borderRadius="50%"
                    />
                    <Text
                      color={activeBullets.user ? 'white' : 'gray.300'}
                      fontWeight={activeBullets.user ? 'bold' : 'normal'}
                      display={{ sm: 'none', md: 'block' }}
                    >
                      Manager Info
                    </Text>
                  </Flex>
                </Tab>
                <Tab
                  _focus={{ border: '0px', boxShadow: 'unset' }}
                  ref={addressTab}
                  w={{ sm: '120px', md: '250px', lg: '300px' }}
                  onClick={() =>
                    setActiveBullets({
                      user: true,
                      address: true,
                    })
                  }
                >
                  <Flex
                    direction="column"
                    justify="center"
                    align="center"
                    position="relative"
                  >
                    <Box
                      zIndex="1"
                      border="2px solid"
                      borderColor={activeBullets.address ? 'white' : 'brand.400'}
                      bgGradient="linear(to-b, brand.400, brand.600)"
                      w="16px"
                      h="16px"
                      mb="8px"
                      borderRadius="50%"
                    />
                    <Text
                      color={activeBullets.address ? 'white' : 'gray.300'}
                      fontWeight={activeBullets.address ? 'bold' : 'normal'}
                      display={{ sm: 'none', md: 'block' }}
                    >
                      Address
                    </Text>
                  </Flex>
                </Tab>
              </TabList>
              <TabPanels mt="24px" maxW={{ md: '90%', lg: '100%' }} mx="auto">
                <TabPanel
                  w={{ sm: '330px', md: '700px', lg: '850px' }}
                  p="0px"
                  mx="auto"
                >
                  <Card p="30px">
                    <Text color={textColor} fontSize="2xl" fontWeight="700" mb="20px">
                      Manager Info
                    </Text>
                    <Flex direction="column" w="100%">
                      <Stack direction="column" spacing="20px">
                        <SimpleGrid columns={{ base: 1, md: 2 }} gap="20px">
                          <InputField
                            mb="0px"
                            id="first"
                            placeholder="eg. Esthera"
                            label="First Name"
                            name="firstName"
                            onChange={handleChange}
                          />
                          <InputField
                            mb="0px"
                            id="last"
                            placeholder="eg. Peterson"
                            label="Last Name"
                            name="lastName"
                            onChange={handleChange}
                          />
                          <InputField
                            mb="0px"
                            id="phone-input"
                            type="tel"
                            placeholder="Enter your phone number "
                            label="Phone Number"
                            name="phoneNumber"
                            onChange={handleChange}
                          />
                          <InputField
                            mb="0px"
                            id="Email"
                            placeholder="eg. hello@simmmple.com"
                            label="Email Address"
                            name="email"
                            onChange={handleChange}
                          />
                        </SimpleGrid>
                      </Stack>
                      <Flex justify="space-between" mt="24px">
                        <Button
                          variant="darkBrand"
                          fontSize="sm"
                          borderRadius="16px"
                          w={{ base: '128px', md: '148px' }}
                          h="46px"
                          ms="auto"
                          onClick={() => addressTab.current.click()}
                        >
                          Next
                        </Button>
                      </Flex>
                    </Flex>
                  </Card>
                </TabPanel>
                <TabPanel
                  w={{ sm: '330px', md: '700px', lg: '850px' }}
                  p="0px"
                  mx="auto"
                >
                  <Card p="30px">
                    <Text color={textColor} fontSize="2xl" fontWeight="700" mb="20px">
                      Address
                    </Text>
                    <Flex direction="column" w="100%">
                      <Stack direction="column" spacing="20px" mb="20px">
                        <InputField
                          mb="0px"
                          id="address"
                          placeholder="Enter your address"
                          label="Address"
                          name="address"
                          onChange={handleChange}
                        />
                        <SimpleGrid columns={{ base: 1, md: 2 }} gap="20px">
                          <InputField
                            mb="0px"
                            id="birthDate"
                            type="date"
                            label="Select Birth Date"
                            name="birthDate"
                            onChange={handleChange}
                          />
                          <InputField
                            mb="0px"
                            id="joiningDate"
                            type="date"
                            label="Select Joining Date"
                            name="joiningDate"
                            onChange={handleChange}
                          />
                        </SimpleGrid>
                      </Stack>
                      <Flex justify="space-between">
                        <Button
                          variant="light"
                          fontSize="sm"
                          borderRadius="16px"
                          w={{ base: '128px', md: '148px' }}
                          h="46px"
                          onClick={() => userTab.current.click()}
                        >
                          Prev
                        </Button>
                        <Button
                          variant="darkBrand"
                          fontSize="sm"
                          borderRadius="16px"
                          w={{ base: '128px', md: '148px' }}
                          h="46px"
                          ms="auto"
                          onClick={handleSubmit}
                        >
                          Submit
                        </Button>
                      </Flex>
                    </Flex>
                  </Card>
                </TabPanel>
              </TabPanels>
            </Tabs>
          </Flex>
      }
    </>
  );
}
